const storageKeyPrefix = 'VistaOmnichannelComponents';
const storageKeySeparator = '::';
export const getStorageKey = (key) => `${storageKeyPrefix}${storageKeySeparator}${key}`;
//# sourceMappingURL=storage-key.js.map